import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './ThemeContext';

// Add font links to the head
const addFonts = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Roboto+Mono&display=swap';
  document.head.appendChild(link);
};

// Add meta tags for better SEO and security
const addMetaTags = () => {
  // Set description
  let meta = document.createElement('meta');
  meta.name = 'description';
  meta.content = 'Upload files to IPFS - InterPlanetary File System - with this easy-to-use decentralized storage tool';
  document.head.appendChild(meta);
  
  // Set keywords
  meta = document.createElement('meta');
  meta.name = 'keywords';
  meta.content = 'IPFS, upload, decentralized, storage, blockchain, web3, freeweb3';
  document.head.appendChild(meta);
  
  // Do not add CSP during development as it can block IPFS requests
};

// Run initialization functions
addFonts();
addMetaTags();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();